import { ApiResponse, ApisauceInstance } from 'apisauce'
import { handleResponse } from '../handleResponse'

export const CardApi = {
  apisauce: {} as ApisauceInstance,

  /**
   * Table - get cards
   */
  getCards: async (
    type: 'cards',
    meta?: boolean,
    columns?: any,
    view_name?: string,
    id?: number,
  ) => {
    const payload = { view_name }
    if (columns && columns.length > 0) {
      payload['columns'] = columns
    }

    const response: ApiResponse<any> = await CardApi.apisauce.post(
      `/${type}/?meta=${meta}&asynchronous=${false}`,
      payload,
    )
    return handleResponse(response)
  },

  /**
   * Create standalone Info Card
   */
  createInfoCard: async (card) => {
    const response: ApiResponse<any> = await CardApi.apisauce.post(`/cards/create/`, card)
    return handleResponse(response)
  },

  /**
   * Create standalone Info Card
   */
  getInfoCard: async (card_id) => {
    const response: ApiResponse<any> = await CardApi.apisauce.get(`/cards/${card_id}/`)
    return handleResponse(response)
  },

  /**
   * Create standalone Info Card
   */
  updateInfoCard: async (payload) => {
    const response: ApiResponse<any> = await CardApi.apisauce.patch(
      `/cards/${payload.id}/`,
      payload,
    )
    return handleResponse(response)
  },

  checkDeleteCard: async (card_id: number) => {
    const response: ApiResponse<any> = await CardApi.apisauce.delete(
      `/cards/${card_id}/?safe=true`,
      {},
      { data: { card_id } },
    )
    return handleResponse(response)
  },

  deleteCard: async (card_id: number) => {
    const response: ApiResponse<any> = await CardApi.apisauce.delete(
      `/cards/${card_id}/?safe=false`,
      {},
      { data: { card_id } },
    )
    return handleResponse(response)
  },
}
